import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { I18nContext } from './I18nContext';
/**
 * Returns a translator than can be used to display messages in a locale-aware way.
 */
const useTranslator = (namespaces) => {
    const context = useContext(I18nContext);
    const { t, i18n } = useTranslation(namespaces, {
        useSuspense: !namespaces || namespaces.length !== 1 || namespaces[0] !== 'local',
        i18n: context,
    });
    return {
        translate: t,
        dir: i18n.dir(),
    };
};
export { useTranslator };
//# sourceMappingURL=useTranslator.js.map